/// <amd-module name="Test/TestPlansHubRefresh/TestCasesImportModule/Redux/TestCasesImportPanelReducer" />
import { default as produce } from "immer";
import { ITestCasesImportPanelState } from "./TestCasesImportPanelContracts";
import { TestCasesImportPanelActions, TestCasesImportPanelActionsTypes } from "./TestCasesImportPanelActions";

/**
 * TestCasesImportPanelReducer: Reducer for test cases import panel
 */
export function TestCasesImportPanelReducer(state: ITestCasesImportPanelState, action: TestCasesImportPanelActions): ITestCasesImportPanelState {
    state = state || ({} as ITestCasesImportPanelState);

    return produce(state, (draftState: ITestCasesImportPanelState) => {
        switch (action.type) {
            case TestCasesImportPanelActionsTypes.csvFileAdded:
                draftState.csvFileAdded = action.payload;
                break;

            case TestCasesImportPanelActionsTypes.updateLoadingState:
                draftState.isLoading = action.payload.isLoading;
                draftState.percentComplete = action.payload.percentComplete;
                break;

            case TestCasesImportPanelActionsTypes.showErrorMessages:
                draftState.isLoading = false;
                draftState.percentComplete = 0;
                draftState.errorMessages = action.payload;
                break;

            default:
                break;
        }
    });
}
